module.exports = __webpack_public_path__ + "static/media/blog-3.2ebaa348.png";